import Repository from "@/plugins/axios";

export default {
  // Получить страницу
  getPage(ident) {
    return Repository.get(`/biennale/custom-page/${ident}`);
  },
};
